// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryCardStyles } from "@rpsc/App/Components/Category/CategoryCard";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { ellipsis } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

categoryCardStyles.cardContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        width: 204px;
        align-items: center;
    `,
};
categoryCardStyles.categoryImageLink = {
    css: css`
        display: flex;
    `,
};

categoryCardStyles.categoryImage = {
    css: css`
        border-radius: 2px;
        height: 204px;
        width: 204px;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    `,
};

categoryCardStyles.categoryNameLink = {
    color: "common.black",
    mergeCss: true,
    typographyProps: {
        size: 16,
        css: css`
            &&& {
                display: flex;
                text-wrap: wrap;
                text-align: center;
                line-height: ${fontConfig.lineHeight.small};
                font-weight: ${fontConfig.weight.bold};
                ${ellipsis(2)}
            }
        `,
    },
};
